<template>
  <v-container>
    <v-row class='mb-5'>
      <template v-if="site.googleAnalyticsRefreshTokenExists && site.googleAnalyticsPropertyIdExists">
        <span class="mt-5" style="color: green;">GA4連携済み</span>
        <v-switch
          label="自動ランキングを表示する"
          class='ml-5'
          v-model="generatePostGroupRankingAutomatically"
        ></v-switch>
      </template>
      <template v-else-if="site.googleAnalyticsRefreshTokenExists">
        <div style="width: 100%;">
          <span style="color: green;">GA4認証済み</span>
          <span class="ml-3" style="font-size: 12px;">
            ※まだ連携は完了していません。「GA4 プロパティID」を設定することで連携が完了します。
          </span>
        </div>
        <v-form ref="propertyId" style="display: flex;">
          <v-text-field
            v-model="propertyId"
            label="GA4 プロパティID"
            :rules="[presenceValidation, positiveNumberPresenceValidation]"
            required
            class="mt-3"
            style="min-width: 100px"
          />
          <v-btn class="mt-5 ml-5" @click="getRankingFirst">
            設定する
          </v-btn>
        </v-form>
      </template>
      <template v-else>
        <v-btn @click="redirectToAuthorizationPage">GA4と連携して自動記事ランキングを作成する</v-btn>
      </template>
    </v-row>
    <v-row>
      <v-tabs v-model="tab">
        <v-tab>手動</v-tab>
        <v-tab>自動</v-tab>
      </v-tabs>
      <v-tabs-items v-model="tab">
        <v-tab-item>
          <post-list-editor
            :group-role="this.$route.params.group_role"
            :group-roles="groupRoles"
          ></post-list-editor>
        </v-tab-item>
        <v-tab-item>
          <template v-if="googleAnalyticsPostRankings.length > 0">
            <v-simple-table class="mb-3">
              <thead>
                <tr>
                  <th class="col-1">ランキング</th>
                  <th class="col-1">slug</th>
                  <th class="col-2"></th>
                  <th class="col-4">記事タイトル</th>
                  <th class="col-4">カテゴリ</th>
                </tr>
              </thead>
              <tbody
                v-for="(postRanking, index) in googleAnalyticsPostRankings"
                :key="postRanking.id"
                class="p-postListRow__block"
              >
                <td class="col-1">{{ index + 1 }}</td>
                <td class="col-1">
                  <a :href="`/preview/${postRanking.post.id}`" target="_blank">/{{ postRanking.post.slug }}</a>
                </td>
                <td class="col-2">
                  <v-img :src="eyecatchableSrc(postRanking.post)" height="100" max-width="100" />
                </td>
                <td class="col-4">{{ postRanking.post.title }}</td>
                <td class="col-2">{{ postRanking.post.category ? postRanking.post.category.name : '' }}</td>
              </tbody>
            </v-simple-table>
          </template>
          <template v-else>
            <div style="width: 1000px; text-align: center; margin-top: 100px;">
              <span style="font-size: 20px; color: gray;">GA4連携を行なってください。</span>
            </div>
          </template>
        </v-tab-item>
      </v-tabs-items>
    </v-row>
  </v-container>
</template>

<script>
import PostListEditor from './editor'
import { mapState } from 'vuex'
import formValidationUtils from '@/mixins/form_validation_utils'
import axios from 'axios'
import { deserialize } from 'deserialize-json-api'

export default {
  components: { PostListEditor },
  props: ['groupRoles'],
  mixins: [formValidationUtils],
  data () {
    return {
      tab: '',
      googleAnalyticsPostRankings: [],
      propertyId: ''
    }
  },
  mounted () {
    axios.get(`/api/google_analytics_post_rankings`).then(
      (data) => {
        this.googleAnalyticsPostRankings = deserialize(data.data).data
      },
      (error) => {
        const payload = {
          status: error.response.status,
          message: error.response.data.errors.toString()
        }
        this.$store.dispatch('SystemMessageStore/createMessage', payload)
      }
    )
  },
  computed: {
    ...mapState({
      site: (state) => state.SiteStore.site
    }),
    generatePostGroupRankingAutomatically: {
      get () {
        return this.site.generatePostGroupRankingAutomatically
      },
      set (newValue) {
        const query = {
          generate_post_group_ranking_automatically: newValue
        }
        axios.patch(`/api/sites/${this.site.id}`, query).then(
          () => {
            const payload = {
              status: 200,
              message: '変更を保存しました'
            }
            this.$store.dispatch('SystemMessageStore/createMessage', payload)
          },
          (error) => {
            const payload = {
              status: error.response.status,
              message: error.response.data.errors.toString()
            }
            this.$store.dispatch('SystemMessageStore/createMessage', payload)
          }
        )
      }
    },
    eyecatchableSrc () {
      return function (post) {
        if (post.eyecatchable) {
          return post.eyecatchable.file.middle.url
        } else {
          return 'http://placehold.jp/eeeeee/cccccc/200x200.png?text=No%20Image'
        }
      }
    }
  },
  methods: {
    redirectToAuthorizationPage () {
      document.cookie = 'currentOrigin=' + window.location.origin + '; domain=' + process.env.APP_DOMAIN + '; path=/;'
      window.location.href = '/google_auth/authorization'
    },
    getRankingFirst () {
      if (!this.$refs.propertyId.validate()) {
        return false
      }
      const query = {
        property_id: this.propertyId
      }
      axios.post('/api/google_analytics_post_rankings', query).then(
        (data) => {
          this.googleAnalyticsPostRankings = deserialize(data.data).data
          const payload = {
            status: 200,
            message: 'プロパティIDを保存しました。ランキング情報を取得しました。'
          }
          this.$store.dispatch('SystemMessageStore/createMessage', payload)
          this.$store.dispatch('SiteStore/fetchSiteReference')
          this.tab = 1
        },
        (error) => {
          const payload = {
            status: error.response.status,
            message: error.response.data.message.toString()
          }
          this.$store.dispatch('SystemMessageStore/createMessage', payload)
        }
      )
    }
  }
}
</script>
